// A leave can mix CL, EL and UL day by day (see server/utils/leaveSegments.js).
// Leaves from before that have no segments and are one type over the range.

const TYPES = ['CL', 'EL', 'UL'];

export const leaveSegments = (leave) => (leave?.segments?.length
    ? leave.segments
    : [{ leaveType: leave?.leaveType, fromDate: leave?.fromDate, toDate: leave?.toDate, days: leave?.days }]);

// "CL" for a single-type leave, "2 CL + 1 EL + 1 UL" for a mixed one.
export const leaveTypeLabel = (leave) => {
    if (!leave || leave.leaveType !== 'MIXED') return leave?.leaveType || '';
    const totals = {};
    leaveSegments(leave).forEach(s => { totals[s.leaveType] = (totals[s.leaveType] || 0) + (s.days || 0); });
    return TYPES.filter(t => totals[t] > 0).map(t => `${Math.round(totals[t] * 100) / 100} ${t}`).join(' + ');
};

// The type covering one calendar day of the leave.
export const leaveTypeOn = (leave, date) => {
    const day = new Date(date); day.setHours(0, 0, 0, 0);
    const seg = leaveSegments(leave).find(s => {
        const from = new Date(s.fromDate); from.setHours(0, 0, 0, 0);
        const to = new Date(s.toDate); to.setHours(23, 59, 59, 999);
        return day >= from && day <= to;
    });
    return seg ? seg.leaveType : leave?.leaveType;
};

// One line per segment, e.g. "15 Oct – 16 Oct: CL (2)". Empty for a single-type leave.
export const leaveBreakdownLines = (leave) => {
    if (!leave?.segments || leave.segments.length < 2) return [];
    const fmt = (d) => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    return leave.segments.map(s => {
        const f = fmt(s.fromDate), t = fmt(s.toDate);
        return `${f}${f === t ? '' : ` – ${t}`}: ${s.leaveType} (${s.days})`;
    });
};
